import gql from "graphql-tag";

export const RESET_PW_QUERY = gql`
  mutation ResetPassword($token: String!, $newPassword: String!) {
    resetUserPassword(token: $token, newPassword: $newPassword)
  }
`;



// WEBPACK FOOTER //
// ./src/screens/Login/SetPasswordForm/queries.ts